import { render, staticRenderFns } from "./InvoicesAdd.vue?vue&type=template&id=0787160b&scoped=true"
import script from "./InvoicesAdd.vue?vue&type=script&lang=js"
export * from "./InvoicesAdd.vue?vue&type=script&lang=js"
import style0 from "./InvoicesAdd.vue?vue&type=style&index=0&id=0787160b&prod&lang=scss"
import style1 from "./InvoicesAdd.vue?vue&type=style&index=1&id=0787160b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787160b",
  null
  
)

export default component.exports